<template>
    <div class="mr-1">
        <div class=" d-flex align-items-center justify-content-between ">
            <div class="px-4 fs-16 fw-500  " style="color: #00448b;">
                <span class="highlighted">Event Logs</span>
            </div>
            <div class="mb-4">
                <button type="button" class="btn-new-call  p-2 fs-14 pointer" @click="showContactsListModal">
                    <i class="el-tooltip icon icon-phone fs-18 text-white icon-custom-style item"></i>
                    <span class="ml-2">
                        Emergency Contact
                    </span>
                </button>
            </div>
        </div>
        <div class="py-3 position-content-main" style="height: auto !important;">
            <div class="page-layout blank">
                <div class="pb-2" style="min-height:fit-content">
                    <div class="d-flex flex-wrap justify-content-between" style="gap:1rem">
                        <div class="breadcrumbnewtheme pb-3">

                            <div class="pre gap-0p5 fw-500 text-capitalize">
                                Facility Management
                            </div>
                            <span style="color:#b2bec3">/</span>
                            <span class="curr gap-0p5 fw-500">
                                List View
                            </span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mb-4" style="gap:.5rem">
                            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                    <!-- <i class="icon-chevron-double-left text-black"></i> -->
                                    <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                            <button @click="previousPage()" :disabled="skip == 0"
                                class="pagination-list-single mt-1 ml-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                    <!-- <i class="icon icon-chevron-left text-black "></i> -->
                                    <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                            <span class="px-2 fw-500 fs-14 mt-1 text-black">Showing {{getSkipCount}} -
                                {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                            <button @click="nextPage()" :disabled="skip_temp >= total"
                                class="pagination-list-single mt-1 mr-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                    <!-- <i class="icon icon-chevron-right text-black"></i> -->
                                    <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                            <button @click="lastPage()" class="mt-1 pointer pagination-list"
                                :disabled="temp_total == total">
                                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                    <!-- <i class="icon-chevron-double-right text-black"></i> -->
                                    <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                        </div>
                    </div>
                    <div class="vendor-list height-fit-content" style="background-color: #f6f8fc !important;">
                        <div class="p-0">
                            <div>
                                <div class="row" style="background:#f0ddb7;">
                                    <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px;">
                                        <div class="mb-3 scroll-new" style="background: white;">
                                            <div v-if="ajax_call_in_progress" class="d-flex align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                                <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="">
                                            </div>
                                            <div v-else-if="list_data.length == 0 && !ajax_call_in_progress" style="min-height: 493px;">
                                                <span class="fw-500 pl-25 pt-10" style="text-align: center !important; line-height:5">No Data Found!</span>
                                            </div>
                                            <div v-else v-for="(data, index) in list_data" :key="index+'iddd'">
                                                <div class="list-box px-4 py-2 pointer" :class="{ 'list-light': index % 2, 'highlight': facility_id == data._id }" @click="getDataById(data._id)">
                                                    <div class="d-flex flex-wrap justify-content-between">
                                                        <span class="fs-14 font-weight-bold text-black">Facility Name: {{data.facility_name || "-"}}</span>
                                                    </div>
                                                    <div class="d-flex flex-wrap justify-content-between mt-2">
                                                        <span class="text-black fw-600" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" :title="data.template_type">Assigned By: {{data.assigned_by || "-"}}</span>
                                                        <!-- <span class="text-black fw-500 hide-line" :title="data.date_time.date">{{data.date_time.date || "-"}}</span> -->
                                                    </div>
                                                    <div class="d-flex justify-content-between mt-2">
                                                        <span class="text-black fw-500 " style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; " :title="data.created_by">Location:
                                                            {{data.location || "-"}}</span>
                                                        <span class="text-black fw-500 hide-line" :title="data.number_of_approves" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                                            {{data.date_time.date.replaceAll('-','/') || "-"}}, {{convertTime24To12(data.date_time.time)}} </span>                                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-6 view-box "
                                        style=" background-color: white !important; height: fit-content ;">
                                        <div class="page-layout blank contacts-manage pt-3"
                                            style="margin-left: 0px !important;margin-right: 0px !important;">
                                                <div v-if="ajax_call_inprogress || ajax_call_in_progress" class="d-flex align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                                    <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                                                </div>
                                                <div v-else-if="!ajax_call_inprogress && is_ticket_not_found" style="min-height: 493px;">
                                                    <span class="fw-500 pl-25 pt-10" style="text-align: center !important; line-height:5">No Data Found!</span>
                                                </div>
                                                <div class="vendor-list br-t-l-r mt-2" id="printId" v-else>
                                                    <div class="mb-3">
                                                        <div
                                                            class=" d-flex align-items-center justify-content-between  ">
                                                            <div class="black-border-bottom">
                                                                <span class=" font-weight-bold pl-1 ">
                                                                    {{ facility_name }} Details</span>
                                                            </div>
                                                        </div>
                                                        <div class="header-detail-view-new mt-5 p-3">
                                                            <div>
                                                                <span class="pl-1 ">Security Concern Details</span>
                                                            </div>
                                                        </div>
                                                        <div class=" mt-3"
                                                            style="box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.16);">
                                                            <div
                                                                class="capture-image d-flex align-items-center p-2 ml-2">
                                                                <span class="text-new-header-black mr-3" style="width: max-content;min-width: max-content;">
                                                                    Details Of Concerns
                                                                </span>
                                                                <div class="inner-line-hr w-100"></div>
                                                                <img v-if="show_hide_general_details" class="pointer capture-image-rotate" @click="showHideGeneralDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                                                                <img v-else class="pointer capture-image-rotate" @click="showHideGeneralDetails" src="/static/images/new-theme2024/etherum-line.svg" width="24" height="24">
                                                            </div>
                                                            <div class="row m-0 mt-3" v-if="show_hide_general_details">

                                                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500" style="white-space: nowrap;overflow: hidden;">Tag Location:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black"><i
                                                                                class="icon icon-map-marker text-black fs-18"></i>{{ tag_location || '-' }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500">Facility
                                                                            Name:</p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black ">{{ facility_name || '-' }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2 align-items-center">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Date and Time
                                                                            of Creation:</p>
                                                                    </div>
                                                                    <!-- <div>
                                                                        <p class="text-black fw-500"
                                                                            style="margin-top: -5px;"><img
                                                                                src="/static/images/new-theme2024/calender_black.svg"
                                                                                class="pr-2"
                                                                                style="margin-top: -5px;" />{{ date_and_time.date || '-' }}
                                                                            <span><img src="/static/images/new-theme2024/time-line.svg" width="25" class="ml-3 mr-2"><span class="">{{ date_and_time.time || '-' }}</span></span>
                                                                        </p>
                                                                    </div> -->
                                                                    <div class="fw-400 d-flex align-items-center mb-2">
                                                                        <img src="/static/images/new-theme2024/calender_black.svg" width="22" />
                                                                        <span class="ml-1 mt-1">
                                                                            {{ date_and_time.date.replaceAll('-','/') || '-' }}
                                                                        </span>
                                                                        <img src="/static/images/new-theme2024/time-line.svg" width="22" class="ml-3" />
                                                                        <span class="ml-1 mt-1">
                                                                            {{ date_and_time.time || '-' }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2" style="flex-wrap: wrap;">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500" style="white-space: nowrap;overflow: hidden;">Template for
                                                                            Ticket:</p>
                                                                    </div>
                                                                    <div style="flex: 1 1 0; min-width: 0;">
                                                                            <p class="text-black" style="overflow-wrap: break-word; word-break: break-word;">{{ ticketType.name || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500">Assigned by:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black ">
                                                                            {{ assigned_by_name || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500">Assigned to:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black ">
                                                                            {{ assignment_details.assigned_to.name  || '-'}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black w-250px fw-500">Comments:</p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black ">
                                                                            {{ comments || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="attachments.length > 0" class=" mt-3 mb-3"
                                                        style="box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.16);">
                                                        <div class="capture-image d-flex align-items-center p-2 px-4">
                                                            <span class="text-new-header-black mr-3"
                                                                style="width: max-content;min-width: max-content;">Attachments</span>
                                                            <div class="inner-line-hr w-100"></div>
                                                                <img v-if="show_hide_attachments_details" class="pointer capture-image-rotate" @click="showHideAttachmentsDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                                                                <img v-else class="pointer capture-image-rotate" @click="showHideAttachmentsDetails" src="/static/images/new-theme2024/etherum-line.svg" width="24" height="24">
                                                        </div>
                                                        <div class="row m-0 mt-3" v-if="show_hide_attachments_details">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 " v-for="(attachment,index) in attachments" :key="index">
                                                                    <div class="d-flex align-items-center mb-2  file-bg" style="border-radius: 4px;box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);background-color: #f5f6f9;">
                                                                        <div class="d-flex align-items-center px-2" style="width:90%">
                                                                            <div>
                                                                                <img
                                                                                src="/static/images/new-theme2024/attachment.svg" />
                                                                            </div>
                                                                            <div class="col">
                                                                                <div class="d-flex justify-content-between p-2">
                                                                                    <el-tooltip :content="attachment.name" placement="top">
                                                                                        <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                            {{attachment.name}}
                                                                                        </div>
                                                                                    </el-tooltip>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <a style="text-decoration: none; z-index: 55">
                                                                            <img src="/static/images/new-theme2024/eye-line.svg" @click="previewImage(attachment)" />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <scan-qr-code v-if="scan_qr_code_modal" @hideQrCode="hideScanQrCode" modal_name="Scan-Qr-Code-Modal">
            </scan-qr-code>
            <emergency-contact-list v-if="contacts_list_modal" @hideModal="hideContactsListModal"
                modal_name="Contacts-List-Modal"></emergency-contact-list>
            <qr-code-popup v-if="qr_code_popup_modal" @hideModal="hideQrCodePopupModal"
                modal_name="Qr-Code-Popup-Modal"></qr-code-popup>
                <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
                <file-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view" :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view" @hideFileViewer="hideFileViewer"></file-viewer>
            <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
            <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        </div>
    </div>
</template>
<script>
    import facility_mgmt from '../mixins/facility_mgmt'
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import moment from 'moment';
var mime = require('mime-types')
const Preview = () => import("../Preview");
    import time_utils from '../mixins/time_utils';
import { EventBus } from '../eventBus/nav-bar-event';
const FileViewer = () => import("../FileViewer.vue")
    const ScanQrCode = () => import("./ScanQrCode")
    const EmergencyContactList = () => import("./EmergencyContactList")
    const QrCodePopup = () => import("./QrCodePopup")
    const createSecurityConcern = () => import("./CreateSecurityConcern")
    export default {
        mixins: [facility_mgmt, time_utils],
        components: {
            ScanQrCode,
            EmergencyContactList,
            SweetModal,
            createSecurityConcern,
            QrCodePopup,
            Preview,
            FileViewer
        },
        data() {
            return {
                success_msg: '',
                warning_msg: '',
                ajax_call_inprogress: false,
                scan_qr_code_modal: false,
                contacts_list_modal: false,
                qr_code_popup_modal: false,
                skip: 0,
                limit: 10,
                total: 0,
                temp_total: 0,
                search_key: '',
                pageLimit: [],
                skip_temp: 0,
                count: 0,
                ajax_call_in_progress: false,
                passed_key: {
                    key: 'facility_name',
                    value: -1
                },
                list_data: [],
                search_mob_active: false,
                facility_id: '',
                show_hide_general_details: true,
                show_hide_attachments_details: true,
                // tag_location:'',
                // comments:'',
                // facility_name:'',
                // date_and_time:'',
                // attachments:'',
                // template_type:'',
                // assignment_details:'',
                // assign_a_ticket:'',
                // assigned_by:'',
                // assigned_by_name:'',
                // ticket_details:'',
                // ticketType:'',
                tag_location: '',
                facility_name: '',
                assigned_by: '',
                comments: '',
                assigned_by_name: '',
                ticketType: '',
                assignment_details: {
                    assigned_to: '',
                    is_assigned: true,
                    to: "person"
                },
                date_and_time: {
                    date: moment(new Date().toString()).format('MM/DD/YYYY'),
                    time: moment(new Date().toString()).format('hh:mm a')
                },
                assign_a_ticket: false,
                attachments: '',
                preview_file: '',
                show_file_viewer: false,
                doc_file_url_type: '',
                file_url_for_view:'',
                file_name_for_view: "",
                file_type_for_view: '',
                active_tab:'details',
                active_tab_body:"details",
                preview_visible: false,
                is_ticket_not_found : false

            }
        },
        methods: {
            previewImage(file) {
                EventBus.$emit('ZindexChangeStart')
                let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
                file['content_type'] = content_type;
                this.preview_file = file;
                if(this.preview_file.name.endsWith('.doc') || this.preview_file.name.endsWith('.docx') || this.preview_file.name.endsWith('.pdf') 
                    || this.preview_file.name.endsWith('.ppt') || this.preview_file.name.endsWith('.pptx') || this.preview_file.name.endsWith('.txt') 
                    || this.preview_file.name.endsWith('.txt') || this.preview_file.name.endsWith('.xls') || this.preview_file.name.endsWith('.xlsx') 
                    || this.preview_file.name.endsWith('.xlsx') || this.preview_file.name.endsWith('.bmp') || this.preview_file.name.endsWith('.jpeg') 
                    || this.preview_file.name.endsWith('.png') || this.preview_file.name.endsWith('.svg') || this.preview_file.name.endsWith('.avi') 
                    || this.preview_file.name.endsWith('.mp3') || this.preview_file.name.endsWith('.mpeg') || this.preview_file.name.endsWith('.mp4')
                    || this.preview_file.name.endsWith('.jpg') || this.preview_file.name.endsWith('.JPG') 
                ){
                    if (/\.(docx|xlsx|pptx|doc|xls|ppt|pdf|svg|txt)$/i.test(file.name)) {
                        this.viewFile(this.preview_file)
                    } else {
                        this.preview_visible = true;
                    }
                } else {
                    this.$toasted.global.error("File Format Not Supported")
                }
            },
            viewFile(file) {
                EventBus.$emit('ZindexChangeStart')
                this.file_url_for_view = file.url || "";
                this.file_name_for_view = file.name;
                this.show_file_viewer = true;
                this.file_type_for_view = file.content_type
            },
            hidePreview(){
            EventBus.$emit('ZindexChangeEnd')
            this.preview_visible = false
        },
        hideFileViewer() {
            EventBus.$emit('ZindexChangeEnd')
            this.show_file_viewer = false;
        },
            showHideAttachmentsDetails() {
                this.show_hide_attachments_details = !this.show_hide_attachments_details
            },
            showHideGeneralDetails() {
                this.show_hide_general_details = !this.show_hide_general_details
            },

            hideScanQrCode() {
                EventBus.$emit('ZindexChangeEnd')
                this.scan_qr_code_modal = false;
                setTimeout(() => {
                    this.$modal.hide('Scan-Qr-Code-Modal');
                }, 500);
            },
            showSearchMobActive() {
                this.search_mob_active = !this.search_mob_active;
            },
            showScanQrCode() {
                EventBus.$emit('ZindexChangeStart')
                this.scan_qr_code_modal = true;
                setTimeout(() => {
                    this.$modal.show('Scan-Qr-Code-Modal');
                }, 500);
            },
            showContactsListModal() {
                EventBus.$emit('ZindexChangeStart')
                this.contacts_list_modal = true;
                setTimeout(() => {
                    this.$modal.show('Contacts-List-Modal');
                }, 500);
            },
            showQrCodePopupModal() {
                EventBus.$emit('ZindexChangeStart')
                this.qr_code_popup_modal = true;
                setTimeout(() => {
                    this.$modal.show('Qr-Code-Popup-Modal');
                }, 500);
            },
            hideQrCodePopupModal() {
                EventBus.$emit('ZindexChangeEnd')
                this.qr_code_popup_modal = false;
                setTimeout(() => {
                    this.$modal.hide('Qr-Code-Popup-Modal');
                }, 500);
            },
            hideContactsListModal() {
                EventBus.$emit('ZindexChangeEnd')
                this.contacts_list_modal = false;
                setTimeout(() => {
                    this.$modal.hide('Contacts-List-Modal');
                }, 500);
            },
            searchData() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.getListViewData();
            },
            setPasskey: function (newKey) {
                this.$set(this.passed_key, 'key', newKey)
                var value = this.passed_key.value == -1 ? 1 : -1
                this.$set(this.passed_key, 'value', value)
                this.getListViewData()
            },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.getListViewData()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.getListViewData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.getListViewData();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.getListViewData();
            },
            async getListViewData() {
                this.list_data = [];
                this.ajax_call_in_progress = true;
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit == null ? 10 : this.limit,
                        search_key: this.search_key.trim(),
                    };
                    let response = await this.listSecurityConcern(params);
                    this.list_data = response.response.security_details;
                    if(response.response.security_details.length != 0) {
                        this.facility_id = this.list_data[0]._id;
                        this.getDataById(this.facility_id);
                        this.is_ticket_not_found = false
                    } else this.is_ticket_not_found = true
                    this.total = response.response.count;
                    this.ajax_call_in_progress = false;
                } catch (error) {
                    console.log(error)
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    this.ajax_call_in_progress = false;
                }
            },
            
            async getDataById(id) {
                this.ajax_call_inprogress = true;
                this.facility_id = id
                try {
                    let params = {
                        security_id: this.facility_id
                    };
                    let response = await this.getSecurityConcernById(params);
                    this.assign_a_ticket = response.response.assign_ticket
                    this.assigned_by = response.response.assigned_by.id
                    this.assigned_by_name = response.response.assigned_by.name
                    if (response.response.hasOwnProperty('ticket_template')) {
                        this.ticketType = {
                            name: response.response.ticket_template.name
                        }
                        this.ticket_details = {
                            ticket_number: response.response.ticket_number,
                            ticket_id: response.response.ticket_id,
                            template_type: response.response.ticket_template.template_type,
                            ticket_status: response.response.ticket_status
                        }
                    }
                    if (response.response.assignment_details) {
                        if (!response.response.assignment_details.is_assigned) {
                            this.assignment_details.assigned_to = {
                                name: '-'
                            }
                            this.assignment_details.to = 'unassigned'
                        } else {
                            this.assignment_details.to = response.response.assignment_details.to
                            this.assignment_details_id = response.response.assignment_details.id
                            this.assignment_details.assigned_to = {
                                id: response.response.assignment_details.id,
                                name: response.response.assignment_details.name
                            };
                        }
                    }
                    this.attachments = response.response.attach_files || [];
                    this.date_and_time.date = response.response.date_time.date
                    this.date_and_time.time = this.convertTime24To12(response.response.date_time.time);
                    this.facility_name = response.response.facility_name;
                    this.tag_location = response.response.location;
                    this.comments = response.response.comments;
                    this.ajax_call_inprogress = false;
                } catch (error) {
                    console.log(error);
                }
            },
            async goToDetailsView(id) {
                this.$router.push('/facilitymanagement/securityconcern/view/' + id);
            }
        },
        mounted() {
            this.getListViewData()
            for (let i = 10; i <= 50; i += 10) {
                this.pageLimit.push(i);
            }
        },
        computed: {
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        },
        destroyed() {

        },
        watch: {
            limit: function () {
                this.getListViewData();
            }
        },
    }
</script>
<style scoped>
    .capture-image-rotate {
        transform: rotate(180deg);
        transition: all 0.3s;
    }

    .active-capture-image-rotate {
        transform: unset;
    }

    .inner-line-hr {
        border: 0;
        width: 100%;
        border-top: 2px solid #bed1f8;
    }
    .btn-new-call {
        background-color: #03855d !important;
        color: white;
        border-radius: 5px;
    }
    .list-light {
        width: 100%;
        object-fit: contain;
        border-radius: 5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 0.5px #f3f6fb;
        background-color: #ffffff;
    }

    .highlight {
        background-color: #d5e2fa !important;
    }

    @media (max-width: 1100px) {
        .hide-line {
            display: none;
        }
    }

    .edit-button {
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 32px !important;
        border-radius: 4px;
    }

    .box-blue-header {
        border-radius: 3px;
    }

    .box-blue-header-parent {
        background: #005dae;
        position: relative;
        top: -1px;
        margin-left: -1px;
    }

    .ticket_count {
        background-color: #7b7f97;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .count-ticket {
        background-color: #1b57ad;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .ticket_tab {
        background-color: #005dae;
    }

    .activeColor {
        background-color: #005dae;
        color: #ffffff;
    }

    .email-buttons {
        display: none;
    }

    @media screen and (max-width: 991px) {
        .mob-list-scroll {
            min-width: 991px;
        }
    }

    .btn-success {
        background-color: #25bb83 !important;
    }

    .ticket-list-button {
        color: #363636;
        border-radius: 6px !important;
        box-shadow: none !important;
        font-weight: 600;
        background-color: #e4e4e4;
        width: 230px;
    }
    .view-box {
        border: 1px solid #a5a5a5;
        border-radius: 6px
    }

    .scm-filters {
        font-family: "Poppins", "Helvetica Neue", sans-serif !important;
        height: 500px;
        overflow: auto;
        max-width: 768px;
        top: 100px;
        background: #e6ecff !important;
    }

    .overflow-visible {
        overflow: scroll !important;
    }
    .col-small-left {
        width: 200px;
    }

    .col-small-right {
        position: relative;
        width: 700px;
    }

    .left-list {
        height: max-content !important;
    }

    @media (max-width: 900px) {
        .scroll-news {
            min-width: 900px;
            overflow-x: scroll !important;
        }
    }

    @media (max-width: 580px) {
        .vendor-list {
            height: 100% !important;
        }

        .left-list {
            height: 500px !important;
        }
    }

    .hor-line {
        width: 2px;
        height: 30px;
        background-color: #1b57ad;
    }

    .filter-box {
        width: 200px;
        height: 30px;
        padding: 2px 3.3px 1.5px 6.5px;
        border: solid 0.5px #363636;
        background-color: #fff;
    }

    .width-fit-content {
        width: fit-content
    }

    .fs-18 {
        font-size: 18px;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .dropbtn {
        background-color: #fff;
        cursor: pointer;
        margin-top: -5px;
        border-radius: 5px;
        line-height: 33px;
    }

    .res-width {
        min-width: 60%
    }

    .ticket_list_number-selected {
        background-color: #00448b !important;
        color: #fff !important;
    }

    .ticket_list_number-selected .li_span {
        color: #fff !important
    }

    .ticket_list_number-selected i {
        color: #fff !important;
        border: 1px solid #fff !important;
    }

    .ticket_list_number-selected i.no-border {
        border: none !important;
    }

    @media screen and (max-width:1347px) {
        .res-width {
            min-width: 75%
        }
    }

    @media screen and (max-width:1011px) {
        .res-width {
            min-width: 100%;
            flex-wrap: wrap
        }
    }


    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #fff;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        z-index: 1;
        right: 0px;
        top: 32px;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed {
        width: 100%;
        vertical-align: middle;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
        background-color: #eee;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .height-fit-content {
        height: fit-content
    }
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: 1px solid rgba(103, 103, 103, 0.84);
        border-radius: 18px;
    }

    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }

    .search-bar {
        margin: 0 30px 0 30px;
    }

    .add-btn {
        margin-right: 24px;
        height: 34px;
    }

    .ht-100px {
        height: 100px;
    }

    .w-15 {
        width: 15% !important
    }

    .w-1 {
        width: 1% !important;
        min-width: 250px !important
    }

    .table-content-data tr th {
        text-transform: capitalize;
        color: #00448b;
        background-color: #e8e9ec;
    }

    .text-white {
        color: #fff !important;
    }

    .text-green {
        color: #038b62 !important;
    }

    .breadcrumbnewtheme {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .breadcrumbnewtheme div {
        color: #00448b;
    }
    .fs-2rem {
        font-size: 2rem;
    }

    .position-content-main {
        border-radius: 14px;
        background-color: #f0ddb7;
    }

    .header-color {
        color: #4e4e4e !important;
    }
</style>